import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

type Props = {
  to: string;
  className?: string;
};

/** Atalho para quem já é constelador e chega pela home ou pelo link do influencer. */
export function ConsteladorEntryCard({ to, className = "" }: Props) {
  const classes = `group relative mb-5 block overflow-hidden rounded-[2rem] border border-[#2b5a41]/10 bg-gradient-to-br from-white via-[#f7f8f4] to-[#e0ede3] p-5 pb-7 text-left shadow-[0_18px_40px_rgba(32,60,46,0.10)] transition duration-300 hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#2b5a41] sm:p-6 sm:pb-8 ${className}`;
  const body = (
    <>
      <span
        className="pointer-events-none absolute -right-10 -top-12 h-36 w-36 rounded-full bg-[#89a78c]/25 blur-2xl"
        aria-hidden
      />
      <span
        className="pointer-events-none absolute -bottom-10 left-6 h-24 w-24 rounded-full bg-[#2b5a41]/10 blur-2xl"
        aria-hidden
      />
      <span className="relative flex flex-col items-start gap-4">
        <span>
          <span className="inline-flex rounded-full bg-[#2b5a41]/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-[#2b5a41]">
            Para quem conduz
          </span>
          <span
            className="cb-page mt-3 block text-[1.65rem] font-bold leading-[1.05] tracking-[-0.04em] text-[#2B5A41]"
          >
            Você é
          </span>
          <span
            className="cb-serif mt-1 block text-[1.7rem] leading-[1.1] text-[#89A78C]"
          >
            Constelador(a)?
          </span>
          <span className="mt-2 block text-sm leading-relaxed text-[#5f7167]">
            Compre horas avulsas ou conheça os nossos planos
          </span>
        </span>
        <span className="inline-flex items-center gap-2 rounded-full bg-[#2B5A41] px-6 py-3 text-sm font-semibold text-white ring-2 ring-[#e7f0e4] shadow-[0_0_0_3px_#89a78c,0_0_22px_5px_rgba(137,167,140,0.95)] transition group-hover:bg-[#203C2E]">
          Clique aqui
          <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden />
        </span>
      </span>
    </>
  );

  if (to.startsWith("#")) {
    return (
      <a href={to} className={classes}>
        {body}
      </a>
    );
  }

  return (
    <Link to={to} className={classes}>
      {body}
    </Link>
  );
}
